import React, { useState } from 'react';
import { Send } from 'lucide-react';
import './Contato.css';

const Contato = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    assunto: '',
    mensagem: ''
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Form submitted:', formData);
    alert('Mensagem enviada com sucesso!');
    setFormData({ nome: '', email: '', assunto: '', mensagem: '' });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  return (
    <div className="contact-page">
      <section className="page-hero contact-hero">
        <div className="page-hero__text">
          <span className="page-hero__eyebrow">Contato</span>   
        </div>
      </section>

      <section id="contato" className="contact-section">
        <div className="contact-container">
          <div className="contact-card">
            <div className="contact-header">
              <h1 className="contact-title">Entre em Contato</h1>
              <p className="contact-description">
                Tem duvidas ou sugestoes sobre o Plano Municipal de Saneamento Basico?
                <br />
                Preencha o formulario abaixo e entraremos em contato o mais breve possivel.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="contact-grid">
                <div className="form-field">
                  <label htmlFor="nome" className="form-label">
                    Nome
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Seu nome completo"
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <div className="form-field">
                <label htmlFor="assunto" className="form-label">
                  Assunto
                </label>
                <input
                  type="text"
                  id="assunto"
                  name="assunto"
                  value={formData.assunto}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Assunto da sua mensagem"
                />
              </div>

              <div className="form-field">
                <label htmlFor="mensagem" className="form-label">
                  Mensagem
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="form-textarea"
                  placeholder="Escreva sua mensagem aqui..."
                />
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-button">
                  <span>Enviar Mensagem</span>
                  <Send size={20} className="submit-icon" aria-hidden="true" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contato;
